import { PLATFORM_CONTENT_TYPE_ENUM, PLATFORM_ENUM } from 'services/api/constants'
import { EngagementId } from 'state/tasks'

export const PLATFORM_CONTENT_TYPE_ENGAGEMENT: Partial<Record<PLATFORM_CONTENT_TYPE_ENUM, EngagementId[]>> = {
    [PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_STORY]: [
        EngagementId.REACH,
        EngagementId.VIEW,
        EngagementId.LIKE,
        EngagementId.IMPRESSION,
        EngagementId.STICKER_TAP,
        EngagementId.LINK_CLICK,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_POST]: [
        EngagementId.REACH,
        EngagementId.VIEW,
        EngagementId.LIKE,
        EngagementId.IMPRESSION,
        EngagementId.SHARE,
        EngagementId.SAVE,
        EngagementId.COMMENT,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_REEL]: [
        EngagementId.REACH,
        EngagementId.VIEW,
        EngagementId.LIKE,
        EngagementId.IMPRESSION,
        EngagementId.SHARE,
        EngagementId.SAVE,
        EngagementId.COMMENT,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.FACEBOOK_POST]: [
        EngagementId.VIEW,
        EngagementId.LIKE,
        EngagementId.IMPRESSION,
        EngagementId.SHARE,
        EngagementId.COMMENT,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.TIKTOK_POST]: [
        EngagementId.REACH,
        EngagementId.VIEW,
        EngagementId.LIKE,
        EngagementId.IMPRESSION,
        EngagementId.SHARE,
        EngagementId.SAVE,
        EngagementId.CTA_CLICK,
        EngagementId.TAG,
        EngagementId.COMMENT,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.TWITTER_POST]: [
        EngagementId.IMPRESSION,
        EngagementId.LIKE,
        EngagementId.RETWEET,
        EngagementId.REPLY,
    ],
    [PLATFORM_CONTENT_TYPE_ENUM.YOUTUBE_VIDEO]: [EngagementId.VIEW, EngagementId.LIKE, EngagementId.COMMENT],
}

export const PLATFORM_CONTENT = {
    [PLATFORM_ENUM.IG]: [
        PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_POST,
        PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_REEL,
        PLATFORM_CONTENT_TYPE_ENUM.INSTAGRAM_STORY,
    ],
    [PLATFORM_ENUM.FB]: [PLATFORM_CONTENT_TYPE_ENUM.FACEBOOK_POST],
    [PLATFORM_ENUM.TIKTOK]: [PLATFORM_CONTENT_TYPE_ENUM.TIKTOK_POST],
    [PLATFORM_ENUM.TWITTER]: [PLATFORM_CONTENT_TYPE_ENUM.TWITTER_POST],
    [PLATFORM_ENUM.YOUTUBE]: [PLATFORM_CONTENT_TYPE_ENUM.YOUTUBE_VIDEO],
}
